import React from 'react';
import { SidebarPortal } from '@plone/volto/components';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import ItemsView from './View';
import schema from './schema';

type ItemsEditProps = {
  selected: boolean;
  block: string;
  data: Record<string, any>;
  onChangeBlock: (block: string, data: Record<string, any>) => void;
  [key: string]: any;
};

const ItemsEdit = ({
  selected,
  block,
  data = {},
  onChangeBlock,
  ...props
}: ItemsEditProps) => {

  return (
    <>
      {/* overriding edit view to manually target image sizes */}
      <div className="items-edit">
        <ItemsView
          {...props}
          data={data}
        />
      </div>

      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          formData={data}
          block={block}
          onChangeField={(id: string, value: any) =>
            onChangeBlock(block, {
              ...data,
              [id]: value,
            })
          }
          onChangeBlock={onChangeBlock}
        />
      </SidebarPortal>
    </>
  );
};

export default ItemsEdit;